/**
 * Main App Component
 *
 * Handles authentication checks and renders the router.
 * All route definitions are in routing/routes.tsx
 */

import { BrowserRouter as Router } from 'react-router-dom'
import { useEffect } from 'react'
import { useAppDispatch } from './store/hooks'
import { checkAuth, clearUserIfTokenInvalid } from './store/slices/authSlice'
import { AppRouter } from './routing'
import './App.css'

function App() {
  const dispatch = useAppDispatch()

  // Check auth on mount
  useEffect(() => {
    dispatch(checkAuth())

    // Periodically check token expiry
    const checkTokenExpiry = () => {
      dispatch(clearUserIfTokenInvalid())
    }

    // Check immediately
    checkTokenExpiry()

    // Check every 5 seconds
    const interval = setInterval(checkTokenExpiry, 5000)

    return () => {
      clearInterval(interval)
    }
  }, [dispatch])

  return (
    <Router>
      <AppRouter />
    </Router>
  )
}

export default App
